// update the easity total
const easifyOptions = document.querySelector(".easify-product-options");
const estotal = document.querySelector(".es_total");
// estotal.style.display = 'none';
let checkexist = setInterval(() => {
  if (easifyOptions) {
    let tpoRadiobutton = easifyOptions.querySelectorAll('.tpo_option-container input');
    if (tpoRadiobutton.length > 0) {
      esoptionhtml();
      esproductprice();
      updateAddon();
      updateTotal();
      hideaddonInput();
      createinputElement();
      clearInterval(checkexist);
    }
  }
}, 250);
// create a html format
function esoptionhtml() {
  easifyOptions.insertAdjacentHTML("beforeend", `
      <div class="es_total">
      <div class="es_Product_total">
          <span class="es_pdp_label">Product Price:</span>
          <span class="es_product_price"></span>
      </div>
      <div class="es_addon_total">
          <span class="es_pdp_label">Add on</span>
          <span class="es_addon_price">-</span>
      </div>
      <div class="es_bundle_total">
          <span class="es_pdp_label">Bundle product</span>
          <span class="es_bundle_price">-</span>
      </div>
      </div>
  `);
}
// product price update function
function esproductprice() {
  const priceEl = document.querySelector(".price__container .price__regular .price-item--regular");
  const targetEl = document.querySelector(".es_product_price");
  // console.log('priceEl', priceEl.textContent);
  if (priceEl && targetEl) {
    targetEl.textContent = priceEl.textContent;
  } 
}
// price update with option change
document.addEventListener('change', function (e) {
  if (e.target.matches('variant-selects input')) {
    setTimeout(() => {
      esproductprice();
    }, 1000);
  }
});
// Add on price update
function updateAddon() {
  document.addEventListener("change", function (e) {
    const input = e.target.closest("label.tpo_undefined.tpo_image_shape_square input");
    if (input) {
      const getaddonTotal = input.closest("label").querySelector(".tpo_additional-price");
      const addontotalSpan = document.querySelector(".es_addon_price");
      if (input.checked && getaddonTotal) {
        let cleanAddonprice = getaddonTotal.textContent.replace(/[()]/g, "").trim();
        addontotalSpan.textContent = cleanAddonprice;
      } else {
        addontotalSpan.textContent = "-";
      }
    }
  });
}
// Bundle price update
function updateTotal() {
  let optionprices = document.querySelector(".tpo_option-type-image-swatches-wrapper");

  let optionpriceSpan = document.querySelector(".tpo_option-type-image-swatches-wrapper span.tpo_additional-price.absolute.active");
  let esbundleprice = document.querySelector(".es_bundle_price");
  let totalSpan = document.querySelector("span.bundle_total");
  if (optionpriceSpan) {
  if (optionpriceSpan.textContent == '') {
    esbundleprice.textContent = '-' 
    totalSpan.textContent = '' 
  } else {
    let cleanoptionprice = optionpriceSpan.textContent.replace(/[()]/g, "").trim();
    optionpriceSpan.textContent = cleanoptionprice;
    if (esbundleprice) esbundleprice.textContent = optionpriceSpan.textContent;
    if (totalSpan) totalSpan.textContent = (' + ') + optionpriceSpan.textContent;
  }
}
}
// add checkbox
function hideaddonInput() {
   const addonInput = document.querySelector("label.tpo_undefined.tpo_image_shape_square input[type='checkbox']");
    if (!addonInput) {
    const addonTotal = document.querySelector(".es_addon_total");
    if (addonTotal) {
      addonTotal.style.display = "none";
    }
  }
  let optionprices = document.querySelector(".tpo_option-type-image-swatches-wrapper");
  const bundleTotal = document.querySelector('.es_bundle_total');
  if (!optionprices) {
      bundleTotal.style.display = 'none';
    }
    if(!addonInput && !optionprices) {
      const AlltotalBOx = document.querySelector(".es_total");
      AlltotalBOx.style.display = 'none';
  }
}
// chreate checkbox to select all bundle
function createinputElement() {
  document.querySelectorAll(".tpo_option-label").forEach(function (wrapper) {
    
    const targetSpan = wrapper.querySelector("span.form__label.tpo_undefined");
    const swatches = wrapper.querySelector(".tpo_option-type-image-swatches-wrapper");
    if (targetSpan && swatches) {
      const allInputs = swatches.querySelectorAll('input[type="checkbox"]'); 
       if (allInputs.length === 0) return;
      const newLabel = document.createElement("label");
      newLabel.className = "es_custom_checkbox_label";
      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.id = "allbundle_check";
      checkbox.className = "es_custom_checkbox";
      newLabel.appendChild(checkbox);
      newLabel.appendChild(targetSpan);
      wrapper.insertBefore(newLabel, swatches);

      // Disable master checkbox if selection unavialable
      const swatchWrappers = wrapper.querySelectorAll(".tpo_image-swatches-wrapper");
      if ([...swatchWrappers].some(sw => sw.classList.contains("swatches-not-avaliable"))) {
        checkbox.disabled = true;
        checkbox.classList.add("disabled"); 
        newLabel.classList.add("disabled"); 
      }

      const alllabel = swatches.querySelectorAll("label");
      
      const allChecked = Array.from(allInputs).every((el) => el.checked);
      const anyChecked = Array.from(allInputs).some((el) => el.checked);

      checkbox.checked = allChecked;
      checkbox.indeterminate = !allChecked && anyChecked;
      // Master checkbox toggle
      checkbox.addEventListener("change", function () {
        if (this.checked) {
          // console.log("allbundles checked");
          allInputs.forEach((inp) => {
            if (!inp.checked) {
            const lab = inp.closest("label");
            lab.dispatchEvent(new PointerEvent("pointerup", { bubbles: true }));
            lab.dispatchEvent(new MouseEvent("click", { bubbles: true }));
            }
          });
        } else {
          // console.log("allbundle unchecked");
          allInputs.forEach((inp) => {
            if (inp.checked) {

            const lab = inp.closest("label");
            lab.dispatchEvent(new PointerEvent("pointerup", { bubbles: true }));
            lab.dispatchEvent(new MouseEvent("click", { bubbles: true }));
            }
          });
        }
      });

      // Sync master checkbox if any swatch is toggled
      allInputs.forEach((inp) => {
        inp.addEventListener("change", function () {
          const allChecked = Array.from(allInputs).every((el) => el.checked);
          const anyChecked = Array.from(allInputs).some((el) => el.checked);

          checkbox.checked = allChecked;
          checkbox.indeterminate = !allChecked && anyChecked;
        });
      });
    }
  });
}
// bundle total update on click in the block
const pdpmainblocks = document.querySelector(".pdp_main_blocks");
if (pdpmainblocks) {
  pdpmainblocks.addEventListener("click", () => {
    updateTotal();
  });
}

//   display only color and swatch variant images
   document.querySelectorAll(".for_cs_swatch").forEach((section) => {
    const filterImages = () => {
      const colorFieldset = section.querySelector(".opt_name_color");
      const seriesFieldset = section.querySelector(".opt_name_series");

      const allLis = Array.from(section.querySelectorAll("li[data-vname]"));

      const colorInput = colorFieldset?.querySelector("input:checked");
      const seriesInput = seriesFieldset?.querySelector("input:checked");
      const colorValue = colorInput?.value?.trim() ?? "";
      const seriesValue = seriesInput?.value?.trim() ?? "";

      allLis.forEach((li) => {
        const v = (li.dataset.vname ?? "").trim();
        const shouldShow =
          v === "" ||
          (colorValue && v === colorValue) ||
          (seriesValue && v === seriesValue);

        li.classList.toggle("hide_swatch_var", !shouldShow);
      });
    };

    filterImages();

 function scrollThumbListToTopForSection(section) {
  const MAX_RETRIES = 12;
  let attempts = 0;

  const findAndScroll = () => {
    attempts++;
    const lists = Array.from(
      document.querySelectorAll(
        ".product__media-wrapper.main__pdp__grid .thumbnail-slider .thumbnail-list"
      )
    );

    if (lists.length === 0) {
      if (attempts < MAX_RETRIES) {
        // wait a bit and retry (shopify might render it shortly)
        setTimeout(findAndScroll, 100);
      }
      return;
    }

    // pick the list closest (vertical distance) to the section
    let targetList = lists[0];
    if (lists.length > 1 && section && section.getBoundingClientRect) {
      const secTop = section.getBoundingClientRect().top;
      let minDist = Infinity;
      lists.forEach((l) => {
        const rect = l.getBoundingClientRect();
        const dist = Math.abs(rect.top - secTop);
        if (dist < minDist) {
          minDist = dist;
          targetList = l;
        }
      });
    }

    // store original inline styles to restore later
    const origScrollBehavior = targetList.style.scrollBehavior || "";
    const origSnapType = targetList.style.scrollSnapType || "";

    // do an immediate jump to top while disabling smooth & snap
    try {
      targetList.style.scrollBehavior = "auto";
      targetList.style.scrollSnapType = "none";

      // two attempts to ensure compatibility
      try {
        targetList.scrollTop = 0;
      } catch (e) {}
      try {
        targetList.scrollTo({ top: 0, left: 0, behavior: "auto" });
      } catch (e) {}
    } finally {
      // restore styles shortly after
      setTimeout(() => {
        targetList.style.scrollBehavior = origScrollBehavior;
        targetList.style.scrollSnapType = origSnapType;
      }, 120);
    }

    // If Shopify/Dawn re-renders the list right after we scroll,
    // observe the list once and reapply a single corrective scroll then disconnect.
    const mo = new MutationObserver((mutations, obs) => {
      // reapply forced jump
      targetList.style.scrollBehavior = "auto";
      targetList.style.scrollSnapType = "none";
      try {
        targetList.scrollTop = 0;
      } catch (e) {}
      try {
        targetList.scrollTo({ top: 0, left: 0, behavior: "auto" });
      } catch (e) {}
      setTimeout(() => {
        targetList.style.scrollBehavior = origScrollBehavior;
        targetList.style.scrollSnapType = origSnapType;
      }, 80);

      obs.disconnect(); // only do it once
    });

    mo.observe(targetList, { childList: true, subtree: true });
  };

  // small initial delay — helps when change triggers rendering
  setTimeout(findAndScroll, 50);
}

    section.addEventListener("change", (e) => {
      console.log('Opt changeddd');
      if (
        e.target.matches("input") &&
        (e.target.closest(".opt_name_color") || e.target.closest(".opt_name_series"))
      ) {
        filterImages();
        scrollThumbListToTopForSection(section);
      }
    });

    const mo = new MutationObserver(() => {
      filterImages();
    });
    mo.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-vname", "class"] });
  });




